import React from 'react'
import * as Icons from './'

const Icon = ({ name, ...rest }) => {
    const IconComponent = Icons[`${name}Icon`]
    if (IconComponent === undefined) {
        console.warn(`Icon with name: ${name} not found.`)
        return <></>
    }

    // Extract potential accessibility props so we can provide sensible defaults.
    const {
        'aria-label': ariaLabel,
        'aria-hidden': ariaHiddenProp,
        ...otherProps
    } = rest

    // If caller explicitly sets aria-hidden, respect it
    // If aria-label is provided, don't hide the icon (let screen reader announce it)
    // If no aria-label, hide the icon (treat as decorative)
    const ariaHidden =
        ariaHiddenProp !== undefined ? ariaHiddenProp : !ariaLabel

    return (
        <IconComponent
            focusable="false"
            aria-label={ariaLabel}
            aria-hidden={ariaHidden}
            {...otherProps}
        />
    )
}

export const CheckIfIconExists = (iconName) => {
    const IconComponent = Icons[`${iconName}Icon`]
    return IconComponent === undefined ? false : true
}
export default Icon
